'use client';
import { useEffect, useMemo } from 'react';
import posthog from 'posthog-js';

interface UserIdentity {
  distinctId: string;
  properties?: {
    [key: string]: any;
  };
}

export function usePostHogIdentity(userIdentity?: UserIdentity) {
  const memoizedUserIdentity = useMemo(() => userIdentity, [JSON.stringify(userIdentity)]);

  useEffect(() => {
    if (
      memoizedUserIdentity?.distinctId &&
      posthog.has_opted_in_capturing() &&
      posthog.get_distinct_id() !== memoizedUserIdentity.distinctId
    ) {
      posthog.identify(memoizedUserIdentity.distinctId, memoizedUserIdentity.properties);
    } else if (!posthog.has_opted_in_capturing()) {
      console.warn('[usePostHogIdentity] PostHog is not ready to capture events.');
    }
  }, [memoizedUserIdentity]);
}
